"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifPrefs = exports.TRANSACTIONAL_EMAIL = void 0;
exports.TRANSACTIONAL_EMAIL = {
    whenUndefined: true,
    group: 46225,
};
exports.NotifPrefs = {
    Mover: {
        email: {
            CTA: {
                keys: ['Mover', 'email', 'CTA'],
                whenUndefined: true,
                group: 14297,
            },
            REMINDERS: {
                keys: ['Mover', 'email', 'REMINDERS'],
                whenUndefined: true,
                group: 46494,
            },
            QUESTIONS: {
                keys: ['Mover', 'email', 'QUESTIONS'],
                whenUndefined: true,
                group: 55847,
            },
            CONTRIBUTION_LIKES: {
                keys: ['Mover', 'email', 'CONTRIBUTION_LIKES'],
                whenUndefined: true,
                group: 58655,
            },
            CONTRIBUTION_COMMENTS: {
                keys: ['Mover', 'email', 'CONTRIBUTION_COMMENTS'],
                whenUndefined: true,
                group: 58656,
            },
        },
        text: {
            MESSAGES: {
                keys: ['Mover', 'text', 'MESSAGES'],
                whenUndefined: false,
            },
            TASKS: {
                keys: ['Mover', 'text', 'TASKS'],
                whenUndefined: false,
            },
        },
    },
    Org: {
        email: {
            SUMMARY: {
                keys: ['Org', 'email', 'SUMMARY'],
                whenUndefined: true,
                group: 46226,
            },
            TASKS: {
                keys: ['Org', 'email', 'TASKS'],
                whenUndefined: true,
                group: 46227,
            },
            NOTES: {
                keys: ['Org', 'email', 'NOTES'],
                whenUndefined: true,
                group: 95241,
            },
        },
    },
};
